<template>
  <v-card class="card-container">
    <v-dialog v-model="importDialog" max-width="400">
      <v-card flat class="pa-6 text-center">
        <div v-if="addResponse.notRegisteredSubDepartments">
          <strong>Alguns dos subsetores não foram importados</strong>
          <p class="mt-3">
            Parece que alguns dos subsetores adicionados já existem no sistema,
            estes não foram importados! O restante dos subsetores foi cadastrado
            com sucesso!
          </p>
        </div>

        <div v-else>
          <strong>Subsetores importados com sucesso!</strong>
          <p class="mt-3">
            Os subsetores foram importados e já estão disponíveis!
          </p>
        </div>

        <div class="d-flex justify-center align-center">
          <v-btn
            class="primary-button ma-0"
            depressed
            @click="
              ;(resendKey = !resendKey),
                (subsectors = []),
                (importDialog = false),
                (file = null)
            "
          >
            Ok
          </v-btn>
        </div>
      </v-card>
    </v-dialog>

    <v-file-input
      class="d-none"
      id="subsetorFile"
      accept=".xlsx"
      :key="resendKey"
      @change="readFile"
    ></v-file-input>

    <div class="back pt-3">
      <div class="main-toolbar mb-2">
        <div class="icon-back">
          <v-icon color="white" size="27">mdi-sticker-plus-outline</v-icon>
        </div>

        <span class="main-toolbar-title">Importar Subsetores</span>

        <v-spacer></v-spacer>

        <div class="d-flex align-center toolbar-actions">
          <v-btn
            class="primary-button mr-2 hidden-sm-and-down"
            depressed
            :disabled="loading"
            @click="downloadModel"
          >
            {{ $t('Baixar planilha modelo') }}
          </v-btn>

          <v-btn
            class="secondary-button mr-2"
            depressed
            :disabled="file == null"
            :loading="tableLoading"
            @click="onFileChange"
          >
            {{ $t('Importar Arquivo') }}
          </v-btn>

          <v-btn
            class="terciary-button mr-2"
            depressed
            dark
            :disabled="subsectors.length == 0"
            :loading="addLoading"
            @click="addSubDepartments"
          >
            Cadastrar subsetores
          </v-btn>

          <v-btn
            v-if="subsectors.length == 0"
            class="quaternary-button"
            depressed
            color="#FF4F64"
            @click="cancel"
          >
            {{ $t('Cancelar') }}
          </v-btn>
          <v-btn
            v-else
            class="quaternary-button"
            depressed
            color="#FF4F64"
            @click="resend"
          >
            Refazer envio
          </v-btn>
        </div>
      </div>

      <v-row class="ma-0" dense align="center">
        <v-col cols="12">
          Aqui você pode importar uma planilha de subsetores para dentro do sistema
          com base na planilha modelo que fornecemos.
          <br />
          A cada importação, confirme se está com a planilha modelo atualizada
          para garantir o funcionamento correto.
        </v-col>
        <v-col v-if="subsectors && subsectors.length == 0">
          <label class="label">{{ $t('Arquivo') }}</label>
          <div class="d-flex justify-center">
            <v-file-input
              v-model="file"
              show-size
              accept=".xls, .xlsx"
              outlined
              dense
              prepend-icon=""
              prepend-inner-icon="mdi-paperclip"
              class="primary-input"
              hide-details="auto"
            >
            </v-file-input>
          </div>
        </v-col>
      </v-row>

      <v-expand-transition>
        <div id="subsectors">
          <v-form ref="form">
            <v-card
              class="ma-2 py-2"
              v-for="(subsector, i) in subsectors"
              :key="i"
              flat
              outlined
            >
              <v-row class="ma-0" dense>
                <v-col cols="1" class="d-flex justify-center align-center">
                  <strong>{{ i + 1 }}</strong>
                </v-col>
                <v-col cols="12" sm="3">
                  <span class="text ml-1">{{ $t('Unidade') }}</span>
                  <v-select
                    append-icon="mdi-chevron-down"
                    hide-details="auto"
                    :menu-props="{ bottom: true, offsetY: true }"
                    :items="unidades"
                    v-model="subsector.unidadeId"
                    clearable
                    item-value="id"
                    item-text="name"
                    class="primary-input"
                    :rules="[(v) => !!v || 'Campo obrigatório']"
                    outlined
                    @change="onUnidadeChange(subsector)"
                  >
                    <template #message="{ message }">
                      {{ $t(message) }}
                    </template>
                  </v-select>
                </v-col>
                <v-col cols="12" sm="4">
                  <span class="text ml-1">{{ $t('Nome do Setor') }}</span>
                  <v-select
                    append-icon="mdi-chevron-down"
                    hide-details="auto"
                    :menu-props="{ bottom: true, offsetY: true }"
                    :items="filteredDepartments(subsector.unidadeId)"
                    v-model="subsector.departmentId"
                    clearable
                    item-value="id"
                    item-text="name"
                    class="primary-input"
                    :rules="[(v) => !!v || 'Campo obrigatório']"
                    outlined
                    @change="onDepartmentChange(subsector)"
                  >
                    <template #message="{ message }">
                      {{ $t(message) }}
                    </template>
                  </v-select>
                </v-col>
                <v-col cols="12" sm="4">
                  <span class="text ml-1">{{ $t('Nome do Subsetor') }}</span>
                  <v-text-field
                    v-model="subsector.name"
                    hide-details="auto"
                    class="primary-input"
                    placeholder="Nome do subsetor"
                    outlined
                    :rules="[(v) => !!v || 'Campo obrigatório']"
                    @keydown.enter="addSubDepartments()"
                  >
                  </v-text-field>
                </v-col>
              </v-row>
            </v-card>
          </v-form>
        </div>
      </v-expand-transition>

    </div>
  </v-card>
</template>

<script>
import ApiService from '../../../../services/ApiService'

export default {
  name: 'ImportSubDepartment',

  data() {
    return {
      loading: false,
      tableLoading: false,
      apiService: new ApiService(),
      subsectors: [],
      departments: [],
      importDialog: false,
      addResponse: {},
      resendKey: false,
      addLoading: false,
      file: null,
    }
  },

  computed: {
    unidades() {
      const map = new Map()
      this.departments.forEach((d) => {
        if (d.unidade && !map.has(d.unidade.id)) {
          map.set(d.unidade.id, d.unidade)
        }
      })
      return Array.from(map.values()).sort((a, b) =>
        a.name.localeCompare(b.name, 'pt-BR')
      )
    },
  },

  created() {
    this.getDepartments()
  },

  methods: {
    filteredDepartments(unidadeId) {
      if (!unidadeId) return this.departments
      return this.departments.filter((d) => d.unidadeId === unidadeId)
    },

    onUnidadeChange(subsector) {
      const dept = this.departments.find((d) => d.id === subsector.departmentId)
      if (dept && dept.unidadeId !== subsector.unidadeId) {
        subsector.departmentId = null
      }
    },

    onDepartmentChange(subsector) {
      const dept = this.departments.find((d) => d.id === subsector.departmentId)
      if (dept) {
        subsector.unidadeId = dept.unidadeId
      }
    },

    resend() {
      this.resendKey = !this.resendKey
      this.subsectors = []
    },

    readFile() {
      if (this.file) {
        const institutionId = JSON.parse(localStorage.getItem('institution')).id
        var reader = new FileReader()
        reader.readAsDataURL(this.file)
        reader.onload = () => {
          this.data = reader.result
          const fileModel = {
            File: this.data,
            InstitutionId: institutionId,
          }

          this.loading = true
          this.apiService
            .post('department/import/subdepartment', fileModel)
            .then((response) => {
              this.subsectors = response.content
              this.loading = false
            })
            .catch(() => {
              this.loading = false
              this.resendKey = !this.resendKey
            })
        }
      }
    },

    downloadModel() {
      let link = document.createElement('a')
      link.setAttribute('type', 'hidden')
      link.href =
        'https://equipacarefix.blob.core.windows.net/public/modelo-subsetor.xlsx'
      link.download =
        'https://equipacarefix.blob.core.windows.net/public/modelo-subsetor.xlsx'
      document.body.appendChild(link)
      link.click()
      link.remove()
    },

    openPicker() {
      const input = document.getElementById('subsetorFile')
      if (input) input.click()
    },

    async getDepartments() {
      const institutionId = JSON.parse(localStorage.getItem('institution')).id
      let url = `department/listActive/${institutionId}`

      await this.apiService.get(url).then((response) => {
        this.departments = response.content
      })
    },

    async addSubDepartments() {
      if (this.$refs.form.validate()) {
        this.addLoading = true
        const model = {
          subDepartments: this.subsectors,
        }

        this.apiService
          .post('department/add-subdepartments', model)
          .then((response) => {
            this.addResponse = response
            this.importDialog = true
            this.addLoading = false
          })
          .catch(() => {
            this.addLoading = false
          })
      } else {
        this.$toast.error('Verifique os campos dos subsetores e tente novamente')
        return
      }
    },

    onFileChange(file) {
      if (file) {
        this.readFile(file)
      }
    },

    cancel() {
      this.file = null
    },
  },
}
</script>

<style scoped>
#subsectors {
  margin-top: 15px;
  max-height: 450px;
  overflow-y: auto;
}

#subsectors::-webkit-scrollbar {
  background-color: #f9f9f9;
  width: 8px;
  border-radius: 6px;
}

#subsectors::-webkit-scrollbar-thumb {
  background-color: #e9e9e9;
  width: 8px;
  border-radius: 6px;
}
</style>
